export const OTP_RESEND_TIME = 1 * 60 * 1000; //Minute convert in Mili second
export const NEXT_PUBLIC_DEFAULT_PAGE_SIZE = 10;

const BASEURL = window.location.protocol + '//' + window.location.host + '/';
export const BASE_URL = BASEURL;